<template>
  <div class="formBox">
    <template v-if="sonUser === 1">
      <div v-if="act === 1">
        <div class="top">
          <div
            style="cursor: pointer"
            @click="setAct(0)"
            :class="contentAct === 0 ? 'act' : ''"
          >
            验证码登录
          </div>
          <div
            style="cursor: pointer"
            @click="setAct(1)"
            :class="contentAct === 1 ? 'act' : ''"
          >
            密码登录
          </div>
        </div>
        <!-- 密码登录 -->
        <div class="pwdLogin" v-show="contentAct === 1">
          <div class="phoneDiv">
            <div class="img"><img src="@/assets/img/login/1.png" alt="" /></div>
            <div class="input">
              <Input
                :border="false"
                name="loginPhone"
                autocomplete="username"
                v-model="formInline.phone"
                placeholder="请输入手机号"
                type="text"
              />
            </div>
          </div>
          <div class="phoneDiv">
            <div class="img"><img src="@/assets/img/login/2.png" alt="" /></div>
            <div class="input">
              <Input
                :border="false"
                name="loginPwd"
                v-model="formInline.password"
                placeholder="请输入密码"
                type="password"
              />
            </div>
          </div>
          <div class="textBox">
            <span class="noAccount"
              >您还没有账号？<span
                class="toRegister"
                @click="$emit('cahngeAct', 0)"
                >立即注册</span
              ></span
            >
            <span class="getPwd" @click="removePwd">忘记密码</span>
          </div>
          <div @click="debounceLogin" class="sub">
            {{ loginTime === null ? "登录" : "登录中" }}
          </div>
        </div>
        <!-- 验证码登录 -->
        <div class="codeLogin" v-show="contentAct === 0">
          <div class="phoneDiv">
            <div class="img"><img src="@/assets/img/login/1.png" alt="" /></div>
            <div class="input">
              <input
                v-model="formInline.getCodePhone"
                placeholder="请输入手机号"
                type="text"
              />
              <Button
                v-throttleClick="2000"
                @click="sendCode('login')"
                class="No-button getCode"
              >
                {{ keyButton }}
              </Button>
            </div>
          </div>
          <div class="phoneDiv">
            <div class="img"><img src="@/assets/img/login/3.png" alt="" /></div>
            <div class="input">
              <input
                v-model="formInline.code"
                placeholder="请输入验证码"
                type="text"
              />
              <input type="text" style="width: 0; opacity: 0; border: none" />
            </div>
          </div>
          <div class="textBox">
            <span class="noAccount"
              >您还没有账号？<span
                class="toRegister"
                @click="$emit('cahngeAct', 0)"
                >立即注册</span
              ></span
            >
          </div>
          <Button v-throttleClick class="No-button sub" @click="codeLogin"
            >登录</Button
          >
        </div>
      </div>
      <div v-if="act === 0">
        <div class="regiter">
          <div class="phoneDiv">
            <div class="img"><img src="@/assets/img/login/1.png" alt="" /></div>
            <div class="input">
              <input
                v-model="regForm.phone"
                placeholder="请输入手机号"
                type="text"
              />
            </div>
          </div>
          <div class="phoneDiv">
            <div class="img"><img src="@/assets/img/login/2.png" alt="" /></div>
            <div class="input">
              <Input
                :border="false"
                v-model="regForm.pwd"
                placeholder="请输入密码"
                type="text"
                class="no-autofill-pwd"
              />
            </div>
          </div>
          <div class="phoneDiv1">
            <div class="img"><img src="@/assets/img/login/3.png" alt="" /></div>
            <div class="input">
              <input
                v-model="regForm.code"
                placeholder="请输入验证码"
                type="text"
              />
              <input type="text" style="width: 0; opacity: 0; border: none" />
              <Button
                v-throttleClick="2000"
                @click="sendCode('regiter')"
                class="getCode No-button"
              >
                {{ keyButton }}
              </Button>
            </div>
          </div>
          <div @click="setSingle" class="tiaokuan">
            <Radio v-model="single"
              >我已阅读并同意
              <!-- <span class="tiaokuan-1" @click="look">《用户使用条款》</span> -->
              <span class="tiaokuan-1" @click="look">《使用协议》</span>
              <span class="tiaokuan-1" @click="toxy">《隐私政策》</span>
            </Radio>
          </div>
          <Button v-throttleClick class="No-button sub" @click="register"
            >注册</Button
          >
        </div>
      </div>
      <div v-if="act === 2">
        <div class="regiter">
          <div class="phoneDiv">
            <div class="img"><img src="@/assets/img/login/1.png" alt="" /></div>
            <div class="input">
              <input
                v-model="removeFrom.phone"
                placeholder="请输入手机号"
                type="text"
              />
            </div>
          </div>
          <div class="phoneDiv">
            <div class="img"><img src="@/assets/img/login/2.png" alt="" /></div>
            <div class="input">
              <Input
                :border="false"
                v-model="removeFrom.pwd"
                placeholder="请输入新密码"
                type="text"
                class="no-autofill-pwd"
              />
            </div>
          </div>
          <div class="phoneDiv1">
            <div class="img"><img src="@/assets/img/login/3.png" alt="" /></div>
            <div class="input">
              <input
                v-model="removeFrom.code"
                placeholder="请输入验证码"
                type="text"
              />
              <input type="text" style="width: 0; opacity: 0; border: none" />
              <Button
                v-throttleClick="2000"
                @click="sendCode('retrieve_pwd')"
                class="No-button getCode"
              >
                {{ keyButton }}
              </Button>
            </div>
          </div>
          <Button
            v-throttleClick
            style="margin-top: 60px"
            class="No-button sub"
            @click="getPwd"
          >
            重置密码
          </Button>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="pwdLogin">
        <div class="phoneDiv">
          <div class="img"><img src="@/assets/img/login/5.png" alt="" /></div>
          <div class="input">
            <Input
              :border="false"
              v-model="sonUserFrom.username"
              placeholder="请输入用户名"
              type="text"
            />
          </div>
        </div>
        <div class="phoneDiv">
          <div class="img"><img src="@/assets/img/login/2.png" alt="" /></div>
          <div class="input">
            <Input
              :border="false"
              v-model="sonUserFrom.password"
              placeholder="请输入密码"
              type="password"
              class="no-autofill-pwd"
            />
          </div>
        </div>
        <Button v-throttleClick @click="Userlogin" class="No-button sub"
          >登录</Button
        >
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "contents",
  props: ["act", "sonUser"],
  watch: {
    act: function () {
      this.destroy();
    },
  },
  created() {
    // const _this = this;
    // document.onkeydown = function (e) {
    //   let key = e.keyCode;
    //   if (key == 13) {
    //     _this.login();
    //   }
    // };
  },
  data() {
    return {
      single: false,
      contentAct: 1,
      sonUserFrom: {
        username: "",
        password: "",
      },
      formInline: {
        phone: "",
        password: "",
        code: "",
        getCodePhone: "",
      },
      removeFrom: {
        pwd: "",
        phone: "",
        code: "",
      },
      regForm: {
        pwd: "",
        phone: "",
        code: "",
      },
      keyButton: "获取验证码",
      keyFlag: true,
      timer: null,
      loginTime: null,
    };
  },
  methods: {
    toxy() {
      window.open("/admin/mPAgreement", "_blank");
    },
    look() {
      window.open("/admin/apptcp", "_blank");
    },
    async getPwd() {
      if (this.removeFrom.phone.length === 0) {
        this.$Message.error("手机号不能为空");
        return;
      }
      const pattern = /^[1]([3-9])[0-9]{9}$/;
      if (!pattern.test(this.removeFrom.phone)) {
        this.$Message.error("手机号格式错误");
        return;
      }
      const pasRegex =
        /(?!.*[\u4E00-\u9FA5\s])(?!^[a-zA-Z]+$)(?!^[\d]+$)(?!^[^a-zA-Z\d]+$)^.{6,16}$/;
      if (this.removeFrom.pwd.length === 0) {
        this.$Message.error("密码不能为空");
        return;
      }
      if (!pasRegex.test(this.removeFrom.pwd)) {
        this.$Message.error(
          "密码由数字、字符和符号至少两种组成，且6-16个字符之间！"
        );
        return;
      }
      if (this.removeFrom.code.length === 0) {
        this.$Message.error("验证码不能为空");
        return;
      }
      let obj = {
        mobile: this.removeFrom.phone,
        pwd: this.removeFrom.pwd,
        validateCode: this.removeFrom.code,
      };
      let res = await this.$apis.loginServe.repwd(obj);
      if (res.resultCode !== "200") {
        this.$Message.error(res.resultDesc);
        return;
      }
      this.$Message.success("修改成功");
      this.$emit("cahngeAct", 1);
    },
    removePwd() {
      this.$emit("cahngeAct", 2);
    },
    successLogin(res) {
      console.log(res);
      let obj = {
        token: res.data.token,
        hasLogin: true,
        userInfo: res.content,
      };
      // console.log(obj);
      this.$store.commit("loginInfo", obj);
      // sessionStorage.setItem("token", res.data.token);
      this.$emit("changeAlert", false);
      // this.$router.go(0)
      // this.$router.go(0);
      // this.$emit("getToken", res.data.token);
    },
    async Userlogin() {
      console.log("----------");
      if (this.sonUserFrom.username.length === 0) {
        this.$Message.error("用户名不能为空");
        return;
      }
      if (this.sonUserFrom.password.length === 0) {
        this.$Message.error("密码不能为空");
        return;
      }
      let obj = {
        password: this.sonUserFrom.password,
        username: this.sonUserFrom.username,
      };

      console.log(obj);
      let res = await this.$apis.loginServe.sonLogin(obj);
      if (res.resultCode !== "200") {
        this.$Message.error(res.resultDesc);
        return;
      }
      this.$Message.success("登录成功");

      this.successLogin(res);
    },
    async codeLogin() {
      if (this.formInline.getCodePhone.length === 0) {
        this.$Message.error("手机号不能为空");
        return;
      }
      const pattern = /^[1]([3-9])[0-9]{9}$/;
      if (!pattern.test(this.formInline.getCodePhone)) {
        this.$Message.error("手机号格式错误");
        return;
      }
      if (this.formInline.code.length === 0) {
        this.$Message.error("验证码不能为空");
        return;
      }

      let obj = {
        username: this.formInline.getCodePhone,
        validateCode: this.formInline.code,
      };
      console.log(obj);
      let res = await this.$apis.loginServe.login(obj);
      if (res.resultCode !== "200") {
        this.$Message.error(res.resultDesc);
        return;
      }
      this.$Message.success("登录成功");
      this.successLogin(res);
    },
    async register() {
      if (this.regForm.phone.length === 0) {
        this.$Message.error("手机号不能为空");
        return;
      }
      const pattern = /^[1]([3-9])[0-9]{9}$/;
      if (!pattern.test(this.regForm.phone)) {
        this.$Message.error("手机号格式错误");
        return;
      }
      if (this.regForm.pwd.length === 0) {
        this.$Message.error("密码不能为空");
        return;
      }
      const pasRegex =
        /(?!.*[\u4E00-\u9FA5\s])(?!^[a-zA-Z]+$)(?!^[\d]+$)(?!^[^a-zA-Z\d]+$)^.{6,16}$/;
      if (!pasRegex.test(this.regForm.pwd)) {
        this.$Message.error(
          "密码由数字、字符和符号至少两种组成，且6-16个字符之间！"
        );
        return;
      }
      if (this.regForm.code.length === 0) {
        this.$Message.error("验证码不能为空");
        return;
      }
      if (!this.single) {
        this.$Message.error("请勾选协议");
        return;
      }
      // console.log(1);
      let obj = {
        password: this.regForm.pwd,
        username: this.regForm.phone,
        validateCode: this.regForm.code,
      };
      let res = await this.$apis.loginServe.reg(obj);
      if (res.resultCode != "200") {
        this.$Message.error(res.resultDesc);
        return;
      }
      this.$emit("cahngeAct", 1);
      this.setAct(1);
      this.$Message.success(res.resultDesc);
      // console.log(res);
    },
    setSingle() {
      this.single = !this.single;
    },
    async login() {
      console.log("___________________");
      this.loginTime = null;
      if (this.formInline.phone.length === 0) {
        this.$Message.error("手机号不能为空");
        return;
      }
      const pattern = /^[1]([3-9])[0-9]{9}$/;
      if (!pattern.test(this.formInline.phone)) {
        this.$Message.error("手机号格式错误");
        return;
      }
      if (this.formInline.password.length === 0) {
        this.$Message.error("密码不能为空");
        return;
      }
      let obj = {
        password: this.formInline.password,
        username: this.formInline.phone,
      };

      console.log(obj);

      let res = await this.$apis.loginServe.login(obj);
      if (res.resultCode !== "200") {
        this.$Message.error(res.resultDesc);
        return;
      }

      this.$Message.success("登录成功");
      // console.log(res);
      this.successLogin(res);
    },
    debounceLogin() {
      // let timer = null; //借助闭包
      if (this.loginTime) {
        clearTimeout(this.loginTime); //进入该分支语句，说明当前正在一个计时过程中，并且又触发了相同事件。所以要取消当前的计时，重新开始计时
        this.loginTime = setTimeout(this.login, 500);
      } else {
        this.loginTime = setTimeout(this.login, 500); // 进入该分支说明当前并没有在计时，那么就开始一个计时
      }
    },
    destroy() {
      clearInterval(this.timer);
      this.keyFlag = true;
      this.keyButton = "获取验证码";
    },
    async sendCode(type) {
      if (this.keyFlag) {
        const pasRegex =
          /(?!.*[\u4E00-\u9FA5\s])(?!^[a-zA-Z]+$)(?!^[\d]+$)(?!^[^a-zA-Z\d]+$)^.{6,16}$/;
        const pattern = /^[1]([3-9])[0-9]{9}$/;
        if (type === "login") {
          if (this.formInline.getCodePhone.length === 0) {
            this.$Message.error("手机号不能为空");
            return;
          }
          if (!pattern.test(this.formInline.getCodePhone)) {
            this.$Message.error("手机号格式错误");
            return;
          }
        } else if (type === "regiter") {
          if (this.regForm.phone.length === 0) {
            this.$Message.error("手机号不能为空");
            return;
          }
          if (!pattern.test(this.regForm.phone)) {
            this.$Message.error("手机号格式错误");
            return;
          }
          if (this.regForm.pwd.length === 0) {
            this.$Message.error("请输入密码");
            return;
          }
          if (!pasRegex.test(this.regForm.pwd)) {
            this.$Message.error(
              "密码由数字、字符和符号至少两种组成，且6-16个字符之间！"
            );
            return;
          }
        } else if (type === "retrieve_pwd") {
          if (this.removeFrom.phone.length === 0) {
            this.$Message.error("手机号不能为空");
            return;
          }
          if (!pattern.test(this.removeFrom.phone)) {
            this.$Message.error("手机号格式错误");
            return;
          }
          if (this.removeFrom.pwd.length === 0) {
            this.$Message.error("请输入密码");
            return;
          }
          if (!pasRegex.test(this.removeFrom.pwd)) {
            this.$Message.error(
              "密码由数字、字符和符号至少两种组成，且6-16个字符之间！"
            );
            return;
          }
        }
        let obj = {
          phone:
            type === "login"
              ? this.formInline.getCodePhone
              : type === "retrieve_pwd"
              ? this.removeFrom.phone
              : this.regForm.phone,
          adapter: type,
        };
        const res = await this.$apis.loginServe.getCode(obj);
        if (res.resultCode == "200") {
          this.$Message.success(res.resultDesc);
          this.getCode();
        } else {
          this.$Message.error(res.resultDesc);
        }
      }
    },
    getCode() {
      this.keyFlag = !this.keyFlag;
      let num = 60;
      this.keyButton = `${num}秒后重新获取`;
      this.timer = setInterval(() => {
        if (num <= 0) {
          this.destroy();
        } else {
          this.keyButton = `${--num}秒后重新获取`;
        }
      }, 1000);
    },
    setAct(i) {
      this.contentAct = i;
    },
  },
  //   regForm: {
  //   pwd: "",
  //   phone: "",
  //   code: "",
  // },
};
</script>

<style lang="scss" scoped>
.formBox {
  width: 300px;
  margin: 0 auto 30px;

  .top {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin: 45px auto 0;
    width: 260px;
    font-size: 18px;

    .act {
      text-align: center;
      line-height: 30px;
      width: 130px;
      height: 45px;

      color: #1d52eb;

      cursor: pointer;
      //background: pink;
      border-bottom: 3px #1d52eb solid;
    }

    div {
      text-align: center;
      line-height: 30px;
      width: 130px;
      height: 45px;
      //background: pink;
      border-bottom: 3px #f3f3f3 solid;
    }
  }
  .No-button {
    margin: 0;
    padding: 0;
    border: none;
    outline: none;
    border-radius: 0;
    background-color: transparent;
    line-height: inherit;
    width: max-content;
  }
  .No-button:hover {
    color: #666666;
  }
  .No-button:active {
    border: none;
  }
  .No-button:focus {
    border: none;
    outline: none;
  }
  .regiter {
    position: relative;
    margin-top: 70px;

    .getPwd {
      right: 0;
      cursor: pointer;
      //bottom: -20px;
      position: absolute;
      width: 50px;
      height: 12px;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #666666;
      line-height: 24px;
    }

    .sub {
      width: 300px;
      height: 50px;
      background: #263d78;
      border-radius: 25px;
      text-align: center;
      line-height: 50px;
      font-size: 20px;
      //margin-top: 77px;
      font-weight: bold;
      color: #ffffff;
      cursor: pointer;
    }

    .phoneDiv1 {
      margin-bottom: 20px;
      width: 300px;
      display: flex;
      //background: pink;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #bfbfbf;
      font-size: 14px;

      .img {
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 14px;
          height: 14px;
        }
      }

      .input {
        width: 270px;
        height: 30px;
        position: relative;

        input {
          width: 170px;
          border: none;
          height: 30px;
          outline: none;
        }

        .getCode {
          cursor: pointer;
          //border: 1px solid #999;
          height: 30px;
          width: 120px;
          text-align: center;
          line-height: 30px;
          position: absolute;
          right: 0;
          top: -5px;
        }
      }
    }

    .phoneDiv {
      margin-bottom: 20px;
      width: 300px;
      display: flex;
      //background: pink;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #bfbfbf;

      .input {
        width: 270px;
        height: 30px;
        ::v-deep .ivu-input,
        input {
          padding: 0;
          border: none;
          width: 270px;
          height: 30px;
          outline: none;
          &::-webkit-input-placeholder {
            color: #757575;
          }
        }

        .no-autofill-pwd {
          ::v-deep .ivu-input-default {
            -webkit-text-security: disc !important;
          }
        }
      }

      .img {
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 14px;
          height: 14px;
        }
      }
    }

    .tiaokuan {
      width: 180px;
      height: 13px;
      font-size: 12px;
      //font-family: Microsoft YaHei;
      font-weight: bold;
      color: #666666;
      line-height: 24px;
      margin-top: 75px;
      margin-bottom: 22px;
      margin-left:-15px;
      .tiaokuan-1 {
        // margin-left: -10px;
      }
      .tiaokuan-2 {
        margin-left: -15px;
      }

      span {
        color: #263d78;
      }
    }
  }

  .pwdLogin {
    position: relative;
    margin-top: 30px;
    .sub {
      width: 300px;
      height: 50px;
      background: #263d78;
      border-radius: 25px;
      text-align: center;
      line-height: 50px;
      font-size: 20px;
      margin-top: 77px;
      font-weight: bold;
      color: #ffffff;
      cursor: pointer;
    }

    .phoneDiv1 {
      margin-bottom: 20px;
      width: 300px;
      display: flex;
      //background: pink;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #bfbfbf;
      font-size: 14px;

      .input {
        width: 270px;
        height: 40px;
        position: relative;

        input {
          width: 170px;
          border: none;
          height: 40px;
          outline: none;
        }

        .getCode {
          cursor: pointer;
          //border: 1px solid #999;
          height: 40px;
          width: 120px;
          text-align: center;
          line-height: 40px;
          position: absolute;
          right: 0;
          top: -5px;
        }
      }
    }

    .phoneDiv {
      margin-bottom: 20px;
      width: 300px;
      display: flex;
      //background: pink;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #bfbfbf;

      .input {
        width: 270px;
        height: 40px;

        ::v-deep .ivu-input,
        input {
          padding: 0;
          border: none;
          width: 270px;
          height: 40px;
          outline: none;
          &::-webkit-input-placeholder {
            color: #757575;
          }
        }
      }

      .img {
        width: 30px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 14px;
          height: 14px;
        }
      }
    }

    .textBox {
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      font-family: PingFang SC;
      .getPwd {
        font-weight: bold;
        color: #666666;
        cursor: pointer;
      }
      .noAccount {
        color: #333333;
        .toRegister {
          color: #1d52eb;
          cursor: pointer;
        }
      }
    }
  }

  .codeLogin {
    position: relative;
    margin-top: 30px;

    .sub {
      width: 300px;
      height: 50px;
      background: #263d78;
      border-radius: 25px;
      text-align: center;
      line-height: 50px;
      font-size: 20px;
      margin-top: 77px;
      font-weight: bold;
      color: #ffffff;
      cursor: pointer;
    }

    .phoneDiv {
      margin-bottom: 20px;
      width: 300px;
      display: flex;
      //background: pink;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #bfbfbf;
      font-size: 14px;

      .input {
        width: 270px;
        height: 40px;
        position: relative;

        input {
          width: 170px;
          border: none;
          height: 40px;
          outline: none;
        }

        .getCode {
          position: absolute;
          right: 0;
          text-align: center;
          line-height: 40px;
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #666666;
          cursor: pointer;
        }

        //input.hover{
        //  border: none;
        //}
      }

      .img {
        width: 30px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 14px;
          height: 14px;
        }
      }
    }

    .textBox {
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      font-family: PingFang SC;
      .getPwd {
        font-weight: bold;
        color: #666666;
        cursor: pointer;
      }
      .noAccount {
        color: #333333;
        .toRegister {
          color: #1d52eb;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
